<mat-expansion-panel
    [expanded]="index == opened && !itemForm.disabled"
    (opened)="opened = index"
    (closed)="opened === index && (opened = -1)"
    [ngClass]="{ 'disabled-material-itemform-expansion-panel': !itemForm.value.item_visibility }"
    [class.material-item-wrapper-collapsed]="!expansionPanel.expanded"
    [disabled]="editMode | async"
    #expansionPanel
>
    <mat-expansion-panel-header
        class="on-hover-mat-item"
        fxLayoutGap="10px"
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        <div fxFlex="grow" fxLayoutGap="5px" fxLayout="row" fxLayoutAlign="start center">
            <mat-checkbox
                [disabled]="!itemForm.value.name"
                (click)="$event.stopPropagation()"
                (change)="$event ? selection?.toggle(index) : null"
                [checked]="selection?.isSelected(index)"
            >
            </mat-checkbox>
            <span
                *ngIf="!(editMode | async)"
                (click)="onClearEditMode.emit(true)"
                fxLayoutGap="3px"
                fxLayout="row"
                fxLayoutAlign="start center"
                class="title-item"
            >
                <mat-icon>link</mat-icon>
                <span *ngIf="!itemForm.value.title">{{ itemForm.value.name }}</span>
                <span *ngIf="itemForm.value.title">{{ itemForm.value.title }}</span>
            </span>
            <mat-form-field *ngIf="editMode.value" class="textarea-title">
                <textarea
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="15"
                    #input
                    matInput
                    (click)="$event.stopPropagation()"
                    (keydown)="$event.stopPropagation()"
                    type="text"
                    [formControl]="itemForm.get('title') | cast"
                >
                </textarea>
            </mat-form-field>
        </div>
        <div class="tools-wrapper" fxLayout="row" fxLayoutAlign="start center">
            <ng-container *ngIf="!editMode.value">
                <button
                    [disabled]="disabled"
                    (click)="$event.stopPropagation(); editMode.next(true); onDisableSorting.emit(true)"
                    class="tools-btn"
                    mat-icon-button
                    matTooltip="Edit title"
                    i18n-matTooltip="@@editTitle"
                >
                    <mat-icon>edit</mat-icon>
                </button>
                <button
                    [disabled]="!itemForm.value.name"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('item_visibility').patchValue(!itemForm.value.item_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.item_visibility
                            ? 'Make it hidden while playing'
                            : 'Make it visible while playing'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.item_visibility ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                <button
                    [disabled]="!itemForm.value.name"
                    (click)="
                        $event.stopPropagation();
                        itemForm.get('headline_visibility').patchValue(!itemForm.value.headline_visibility)
                    "
                    class="tools-btn"
                    mat-icon-button
                    [matTooltip]="
                        itemForm.value.headline_visibility
                            ? 'Hide headline in playing mode'
                            : 'Show headline in playing mode'
                    "
                    i18n-matTooltip
                >
                    <mat-icon>{{ itemForm.value.headline_visibility ? 'format_size' : 'format_clear' }}</mat-icon>
                </button>
                <button
                    [disabled]="!itemForm.value.name"
                    mat-icon-button
                    class="tools-btn-icon"
                    (click)="$event.stopPropagation()"
                    [matMenuTriggerFor]="otherToolsMenu"
                    #otherToolsMenuTrigger="matMenuTrigger"
                    i18n-matTooltip="@@otherTools"
                    matTooltip="Other tools"
                >
                    <mat-icon class="kd-icon-24">spoke</mat-icon>
                </button>

                <ng-content *ngIf="!expansionPanel.expanded"></ng-content>
            </ng-container>
            <button
                *ngIf="editMode.value"
                (click)="$event.stopPropagation(); editMode.next(false); onDisableSorting.emit(false)"
                class="tools-btn-icon"
                mat-icon-button
                matTooltip="Confirm"
                i18n-matTooltip="@@confirm"
            >
                <mat-icon>check</mat-icon>
            </button>
        </div>
    </mat-expansion-panel-header>
    <div class="link-wrapper" fxLayout="column">
        <mat-form-field fxFlex="0 1 100%" class="mb-4">
            <input
                matInput
                #link_input
                placeholder="Link"
                type="url"
                i18n-placeholder
                [formControl]="itemForm.get('name') | cast"
            />
            <button
                matTooltip="Open link in new tab"
                i18n-matTooltip
                type="button"
                [disabled]="!itemForm.value.name || (!!itemForm.value.name && !Utils.isUrl(itemForm.value.name))"
                class="open-link"
                mat-icon-button
                matSuffix
                (click)="goToLink(itemForm.value.name)"
            >
                <mat-icon>open_in_new</mat-icon>
            </button>
        </mat-form-field>
        <div
            *ngIf="!!itemForm.value.name && Utils.isUrl(itemForm.value.name)"
            fxLayoutAlign="start start"
            fxLayoutGap="10px"
            fxLayout.lt-md="column"
        >
            <app-media-view
                fxLayoutAlign="center center"
                *ngIf="mediaKey as mediaId"
                fxFlex="0 0 100%"
                [media_id]="mediaId"
            >
            </app-media-view>
            <ng-container *ngIf="!!itemForm.value.name && Utils.isYoutubeURL(itemForm.value.name)">
                <ng-container *ngIf="youTubeVideoInfo$ | async; let videoData; else: youTubeNoInfo">
                    <div class="info-wrapper" fxLayout="column" fxLayoutGap="10px">
                        <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Video title: </span>
                            <span class="info">{{ videoData.title }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Duration: </span>
                            <span class="info">{{ videoData.duration | formatIsoDuration }}</span>
                        </div>
                        <div fxLayoutAlign="start center" fxLayoutGap="5px">
                            <span class="info-title" i18n>Source: </span>
                            <span class="info">Youtube</span>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
        </div>
    </div>
    <ng-template #youTubeNoInfo
        ><ng-container *ngIf="isLoadingVideoInfo" [ngTemplateOutlet]="smallLoading"></ng-container>
    </ng-template>

    <ng-template #smallLoading>
        <app-kd-logo-loading size="small"></app-kd-logo-loading>
    </ng-template>
</mat-expansion-panel>
<mat-menu
    #otherToolsMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="other-tools-menu-backdrop"
>
    <button
        mat-icon-button
        class="tools-btn-icon other-tools-btn"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="addNewBlockMenu"
        #addNewBlockMenuTrigger="matMenuTrigger"
        i18n-matTooltip="@@otherTools"
        matTooltip="Other tools"
    >
        <mat-icon>add</mat-icon>
        <span i18n>Add new block</span>
        <mat-icon>expand_more</mat-icon>
    </button>
    <button
        *ngIf="itemForm.value.id"
        [disabled]="!itemForm.value.name"
        (click)="onCreateTestFromMaterial.emit(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn copy"
        mat-button
    >
        <mat-icon fontSet="klickdata" fontIcon="kd-icon-test" class="create-quiz-tb"></mat-icon>
        <span i18n>Create a Quiz</span>
    </button>
    <button
        [disabled]="!itemForm.value.name"
        (click)="duplicateItem(index); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn"
        mat-button
    >
        <mat-icon class="material-icons-outlined">file_copy</mat-icon>
        <span i18n>Duplicate</span>
    </button>
    <button
        [disabled]="!itemForm.value.name"
        (click)="copyItem({ title: 'Link', name: itemForm.value.name }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn-icon tools-btn copy"
        mat-button
    >
        <mat-icon class="material-icons-outlined">content_copy</mat-icon>
        <span i18n>Copy to clipboard</span>
    </button>
    <button (click)="deleteItem(index); otherToolsMenuTrigger.closeMenu()" class="tools-btn" mat-button>
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span i18n>Delete</span>
    </button>
</mat-menu>
<mat-menu
    #addNewBlockMenu="matMenu"
    [hasBackdrop]="true"
    [overlapTrigger]="false"
    backdropClass="add-new-block-menu-backdrop"
>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'text' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>post_add</mat-icon>
        <span i18n>Text block</span>
    </button>
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'image' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_photo_alternate</mat-icon>
        <span i18n>Image block</span>
    </button>
    <!-- <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'file' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>cloud_upload</mat-icon>
        <span i18n>Upload file</span>
    </button> -->
    <button
        (click)="onAddNewBlock.emit({ index: index, blockType: 'link' }); otherToolsMenuTrigger.closeMenu()"
        class="tools-btn"
        mat-button
    >
        <mat-icon>add_link</mat-icon>
        <span i18n>Link block</span>
    </button>
</mat-menu>
